import { IconProps } from "../../utils/global-types/global-types";

const HourglassIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M11.268 1.784v-.602h.716c.04 0 .074-.033.074-.074V.074A.074.074 0 0 0 11.984 0H2.016a.074.074 0 0 0-.074.074v1.034c0 .04.033.074.074.074h.716v.602c0 1.978.94 3.78 2.399 4.61.1.13.335.473.301.788a.56.56 0 0 1-.218.377c-1.509.808-2.482 2.632-2.482 4.657v.603h-.716a.074.074 0 0 0-.074.073v1.034c0 .041.033.074.074.074h9.968c.04 0 .074-.033.074-.074v-1.034a.074.074 0 0 0-.074-.073h-.716v-.603c0-2.024-.973-3.848-2.482-4.658a.56.56 0 0 1-.218-.376c-.033-.314.202-.657.302-.788 1.459-.83 2.398-2.632 2.398-4.61m-3.286 5.46q.05.467.457.793l.046.03c1.332.7 2.193 2.33 2.193 4.15v.381H3.322v-.382c0-1.82.86-3.448 2.193-4.15a.3.3 0 0 0 .045-.03q.409-.323.459-.792c.059-.563-.307-1.073-.467-1.266a.3.3 0 0 0-.085-.07c-1.304-.716-2.145-2.334-2.145-4.124v-.381h7.357v.381c0 1.79-.842 3.409-2.145 4.123a.3.3 0 0 0-.085.07c-.16.194-.527.705-.467 1.267"
    ></path>
    <path
      fill="currentColor"
      d="M9.298 3.617a.07.07 0 0 0-.013-.078.07.07 0 0 0-.078-.02L5.552 4.706a.07.07 0 0 0-.05.053.07.07 0 0 0 .022.07q.248.235.506.378l.216.118.15.18c.247.298.426.613.534.934a.074.074 0 0 0 .14 0c.108-.321.288-.636.536-.935l.149-.18.215-.117c.54-.297 1.024-.876 1.328-1.59M7.834 8.722l-.1-.08a2 2 0 0 1-.665-.887c-.02-.058-.116-.058-.138 0-.125.339-.348.638-.664.888l-.089.072-.115.06c-.879.463-1.542 1.6-1.689 2.9a.074.074 0 0 0 .073.082h5.107a.073.073 0 0 0 .073-.083c-.147-1.3-.81-2.437-1.688-2.899z"
    ></path>
  </svg>
);

export default HourglassIcon;
